import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { mutateFieldsKeys } from './mutateKeyFactory';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { LoadFieldValuesRequest } from '../../Model/requests/LoadFieldValuesRequest';
import { FieldValuesResponse } from '../../Model/responseDtos/FieldValuesResponse';

export function useLoadFieldValues(): UseMutationResult<
  FieldValuesResponse,
  unknown,
  { fieldId: number; request: LoadFieldValuesRequest },
  unknown
> {
  const servicesCtx = useContext(ServicesContext);

  const loadFieldValues = (fieldId: number, request: LoadFieldValuesRequest) => {
    if (servicesCtx?.fieldsService) {
      return servicesCtx.fieldsService.loadFieldValues(fieldId, request);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateFieldsKeys.loadFieldValues,
    mutationFn: ({ fieldId, request }) => loadFieldValues(fieldId, request)
  });
}
